import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DayPicker from 'react-day-picker';
import { DayPickerStyles } from '../../../../DayPickerStyle';

import { times } from 'lodash/fp';
import moment from 'moment';
import HoverButton from '../HoverButton/index';
import {
  Container,
  CalendarContainer,
  CurrentFilter,
  Arrow,
  Options,
} from './DateFilter.style';

const getNumDisplayMonths = (sourceMonth, destinationMonth) => {
  if (sourceMonth <= destinationMonth) {
    return destinationMonth - sourceMonth + 1;
  }
  return 13 - sourceMonth + destinationMonth;
};

class DateFilter extends Component {
  static propTypes = {
    setMainDay: PropTypes.func.isRequired,
    maxDays: PropTypes.number,
    selectedDay: PropTypes.instanceOf(Date),
  };
  constructor(props) {
    super(props);
    this.datepicker = React.createRef();
  }
  state = {
    currentFilter: 'Next five days',
    showOptions: false,
    hoveredMonth: moment(),
  };
  hoverMonth = monthIndex => {
    const newMonth = moment().add(monthIndex, 'months');
    if (newMonth.month() !== this.state.hoveredMonth.month()) {
      this.setState({ hoveredMonth: newMonth });
    }
  };
  toggleOptions = () => {
    if (!this.state.showOptions) {
      this.setState({ showOptions: true, hoveredMonth: moment() });
    } else this.setState({ showOptions: false });
  };
  handleDateClick = (date, modifiers = {}) => {
    if (!modifiers.disabled) {
      this.setState({
        currentFilter: moment(date).format('MMMM YYYY'),
        showOptions: false,
      });
      this.props.setMainDay(moment(date));
    }
  };
  handleOptionClick = option => {
    if (option === 'Next five days') {
      this.props.setMainDay(moment());
      this.setState({
        currentFilter: option,
        showOptions: false,
      });
    } else {
      const month = moment().add(option, 'months');
      this.props.setMainDay(month);
      this.setState({
        showOptions: false,
        currentFilter: month.format('MMMM YYYY'),
      });
    }
  };
  handleClose = () => {
    this.setState({ showOptions: false });
  };
  normaliseIndex = () => {
    const adjusted = this.state.hoveredMonth.month() - moment().month();
    if (adjusted < 0) return adjusted + 12;
    return adjusted;
  };
  getCalendarHeight = () => {
    let index = this.normaliseIndex();
    if (this.state.currentFilter !== 'Next five days') {
      index++;
    }
    const baseHeight = index * 40;
    return baseHeight + 20;
  };
  render() {
    const minDay = moment();
    const maxDay = moment().add(this.props.maxDays, 'days');
    const selectedDay = this.props.selectedDay || new Date();
    const open = this.state.showOptions;
    return (
      <Container
        onMouseLeave={this.handleClose}
        open={open}
        pose={open ? 'open' : 'closed'}
      >
        <DayPickerStyles />
        <CurrentFilter onClick={this.toggleOptions}>
          <div>{this.state.currentFilter}</div>
          <Arrow open={open} />
        </CurrentFilter>
        {open && (
          <CalendarContainer height={this.getCalendarHeight()}>
            <DayPicker
              month={this.state.hoveredMonth.toDate()}
              ref={this.datepicker}
              onDayClick={this.handleDateClick}
              selectedDays={selectedDay}
              disabledDays={[
                {
                  before: minDay.toDate(),
                  after: maxDay.toDate(),
                },
              ]}
            />
          </CalendarContainer>
        )}
        <Options pose={open ? 'open' : 'closed'}>
          {this.state.currentFilter !== 'Next five days' ? (
            <HoverButton
              hoverMonth={this.hoverMonth}
              onClick={() => this.handleOptionClick('Next five days')}
              label="Next five days"
            />
          ) : null}
          {times(i => (
            <HoverButton
              key={i}
              onClick={() => this.handleOptionClick(i)}
              label={moment()
                .add(i, 'months')
                .format('MMMM YYYY')}
              isHovered={this.normaliseIndex() === i}
              hoverMonth={this.hoverMonth}
              monthIndex={i}
            />
          ))(getNumDisplayMonths(minDay.month(), maxDay.month()))}
        </Options>
      </Container>
    );
  }
}

export default DateFilter;
// for Testing
export { DateFilter, getNumDisplayMonths };
